<div class="row">
  <div class="col">
    <label class="form-label">Preview country</label>
    <input type="text" class="form-control" [(ngModel)]="country"
      [ngModelOptions]="{standalone: true}" (change)="refresh()">
  </div>
  <div class="col-auto d-flex">
    <button class="btn btn-primary align-self-end" (click)="refresh()" type="button">Refresh</button>
  </div>
</div>
<div class="w-100 position-relative mt-3">
  <iframe #iframe width="100%"></iframe>
  @if (loading) {
    <div class="static-page-loader">
      <div class="d-flex align-items-center justify-content-center h-100">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
</div>
